/*eslint no-undef: "off"*/

// Children of ViewAuthenticated for inventory / payer coverage
export const inventoryRoutes = [
    {
        path: 'inventory',
        component: () => import('@/features/inventory/views/InventoryRouterView.vue'),
        meta: { title: 'Inventory' },
        beforeEnter() {
            const currentUser = useCurrentUserStore()

            if (!currentUser.isAdmin) return { path: '/home' }
        },
        children: [
            {
                path: '',
                name: 'inventory',
                redirect: { name: 'inventory-payers-index' },
            },
            {
                path: 'payers',
                components: {
                    default: () => import('@/features/inventory/views/payers/InventoryPayersRouterView.vue'),
                    'payer-heading': () =>
                        import('@/features/inventory/views/payers/InventoryPayersRouterHeadingView.vue'),
                },
                children: [
                    {
                        path: '',
                        name: 'inventory-payers-index',
                        components: {
                            default: () => import('@/features/inventory/views/payers/InventoryPayersIndexView.vue'),
                        },
                        meta: { title: 'Payers' },
                    },
                    {
                        path: ':payerSlug',
                        name: 'inventory-payers-show',
                        components: {
                            default: () =>
                                import('@/features/inventory/views/payers/[payerSlug]/InventoryPayersPayerSlugView.vue'),
                        },
                        children: [
                            {
                                name: 'inventory-payers-show-networks',
                                path: 'networks',
                                component: () =>
                                    import('@/features/inventory/views/payers/[payerSlug]/networks/InventoryPayerNetworksView.vue'),
                                children: [
                                    {
                                        path: ':networkSlug?',
                                        name: 'inventory-payers-show-networks-show',
                                        component: () =>
                                            import('@/features/inventory/views/payers/[payerSlug]/networks/[networkSlug]/InventoryPayersPayerSlugNetworksNetworkSlugView.vue'),
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
]
